/**
 * Utilitários para WhatsApp
 */

export class WhatsAppUtil {
  /**
   * Obtém o número do WhatsApp configurado no .env
   */
  private static getWhatsAppNumber(): string {
    return import.meta.env.VITE_WHATSAPP_NUMBER || '';
  }

  /**
   * Formata o número do telefone para o padrão do WhatsApp
   * Remove caracteres especiais e espaços
   */
  private static formatPhoneNumber(phone: string): string {
    return phone.replace(/\D/g, '');
  }

  /**
   * Cria a URL do WhatsApp Web com a mensagem
   */
  private static createWhatsAppUrl(phone: string, message: string): string {
    const formattedPhone = this.formatPhoneNumber(phone);
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
  }

  /**
   * Envia mensagem para solicitar estoque a outro vendedor
   */
  static solicitarEstoque(params: {
    vendedorNome: string;
    produtoCodigo: string;
    produtoNome: string;
    quantidadeDisponivel: number;
  }): void {
    const { vendedorNome, produtoCodigo, produtoNome, quantidadeDisponivel } = params;
    const whatsappNumber = this.getWhatsAppNumber();

    if (!whatsappNumber) {
      console.error('Número do WhatsApp não configurado no .env');
      alert('Número do WhatsApp não configurado. Entre em contato com o administrador.');
      return;
    }

    // Monta a mensagem
    const message = `Olá ${vendedorNome}!\n\n` +
      `Gostaria de solicitar estoque do seguinte produto:\n\n` +
      `*Código:* ${produtoCodigo}\n` +
      `*Produto:* ${produtoNome}\n` +
      `*Quantidade Disponível:* ${quantidadeDisponivel}\n\n` +
      `Você poderia liberar uma parte desse estoque para mim?\n\n` +
      `Obrigado!`;

    // Cria a URL do WhatsApp
    const url = this.createWhatsAppUrl(whatsappNumber, message);

    // Abre em nova aba
    window.open(url, '_blank');
  }

  /**
   * Envia mensagem personalizada via WhatsApp
   */
  static enviarMensagem(phone: string, message: string): void {
    const url = this.createWhatsAppUrl(phone, message);
    window.open(url, '_blank');
  }
}
